<template>
  <div>
    <vue-typeahead-bootstrap
      v-model="chosen"
      :data="suggestions"
      :serializer="(item) => item.name"
      @hit="onSuggestSelect"
      @input="getSuggestionList()"
    />

    <!-- <vue-simple-suggest
      v-model="chosen"
      display-attribute="name"
      value-attribute="id"
      style="width:100%"
      :list="getSuggestionList"
      @select="onSuggestSelect"
      @request-done="onRequestDone"
    >
    </vue-simple-suggest> -->
  </div>
</template>

<script>
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
export default {
  components: {
    VueSimpleSuggest,
  },
  data() {
    return {
      suggestions: null,
      chosen: "",
    };
  },
  props: { value: { type: String, default: "" } },
  methods: {
    onRequestDone(request) {
      if (request.length == 0) this.$emit("hasData", this.chosen);
      else this.$emit("hasData", null);
    },
    onSuggestSelect(suggest) {
      console.log(suggest);
      this.selected = suggest;
      this.$emit("nameSelected", suggest);
    },
    getSuggestionList() {
      return this.$client
        .get("/api/customer/searchCustomer?name=" + this.chosen)
        .then((response) => {
          var users = response.data.value;

          this.suggestions = users.map(function(a) {
            var user = { id: a.id, name: a.firstName + " " + a.lastName };

            return user;
          });
        });
    },
  },
};
</script>

<style></style>
